/**
 * Brand system e-Log — loghi ufficiali riutilizzabili (R60.25).
 * Palette derivata dai loghi PNG/JPG in /public:
 *  - Navy: #12244A · Navy-light: #1E3D6E
 *  - Gold: #E8A63E · Gold-light: #F4C57C
 *  - Cream: #FAF7F0
 */

// Sa.Gi Group logo — usa file JPG originale
export function SaGiLogo({ size = 40, className = "" }) {
  return (
    <img
      src="/sagi-logo.jpg"
      alt="Sa.Gi Group"
      width={size}
      height={size}
      className={`rounded-xl object-contain shadow-sm bg-white ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

// e-Log Ristorazione — pentola con fumo e spunta (SVG inline branded)
export function ELogRistorazioneLogo({ size = 48, className = "" }) {
  return (
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      className={className}
      aria-label="e-Log Ristorazione"
    >
      {/* Fumo con spunta oro */}
      <path d="M22 4c-1.5 3 1.5 4-1 8c-1 1.5 0 3 2 3s3-1.5 2-3c-2-3 1-5-1-8Z" fill="#E8A63E"/>
      <path d="M15 21l3 3 6-7" stroke="#E8A63E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      {/* Pentola navy */}
      <path d="M8 22h32v3H8z" fill="#12244A"/>
      <path d="M10 25h28v14a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V25Z" fill="#12244A"/>
      <path d="M6 30h4v6H6zM38 30h4v6h-4z" fill="#12244A"/>
    </svg>
  );
}

// e-Log Manuale — libro con spunta oro (NUOVO logo R60.25)
export function ELogManualeLogo({ size = 48, className = "" }) {
  return (
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      className={className}
      aria-label="e-Log Manuale"
    >
      {/* Copertina navy */}
      <path d="M8 8h32v32a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V8Z" fill="#12244A"/>
      {/* Dorso ricamato oro */}
      <rect x="8" y="8" width="4" height="34" fill="#E8A63E"/>
      {/* Righe di testo bianche */}
      <rect x="16" y="14" width="18" height="2" rx="1" fill="#FAF7F0" opacity="0.9"/>
      <rect x="16" y="19" width="14" height="1.5" rx="0.75" fill="#FAF7F0" opacity="0.7"/>
      <rect x="16" y="23" width="16" height="1.5" rx="0.75" fill="#FAF7F0" opacity="0.7"/>
      {/* Grande spunta oro */}
      <circle cx="34" cy="34" r="8" fill="#E8A63E"/>
      <path d="M30 34l2.5 2.5 5-5" stroke="#12244A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  );
}

// Wordmark "e-Log" testuale (per header)
export function ELogWordmark({ dark = false, size = "md", className = "" }) {
  const sz = size === "sm" ? "text-base" : size === "lg" ? "text-2xl" : "text-lg";
  const c = dark ? "text-white" : "text-[#12244A]";
  const acc = "text-[#E8A63E]";
  return (
    <span className={`font-black ${sz} ${c} tracking-tight ${className}`}>
      e-Log <span className={acc}>HACCP</span>
    </span>
  );
}
